<template>
    <content-string-create :client-id="null" :back-route="{ name: 'system-content-strings' }" />
</template>
<script>
import ContentStringCreate from '../../common/content/string/content-string-create.vue'

export default {
    name: 'system-content-strings-create',
    components: { ContentStringCreate }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/content/strings/create.vue